import script from "./SellerProductPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerProductPreview.vue?vue&type=script&setup=true&lang=ts"

import "./SellerProductPreview.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__